import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-4 border" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "mb-4 text-primary" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-start gap-2"
}

import { computed, inject } from "vue";
  import OpeningHoursTable from "./OpeningHoursTable.vue";
  import WeekdayOpeningHours from "./WeekdayOpeningHours.vue";
  import DeleteEntries from "./DeleteEntries.vue";
  import dayjs from "dayjs";
  import "dayjs/locale/de";

  
export default {
  __name: 'OpeningHoursBlock',
  props: {
    entries: { type: Array, required: true },
    modalId: { type: String, required: false, default: null },
  },
  setup(__props) {

  dayjs.locale("de");

  const props = __props;

  const permissions = inject("permissions");
  const saveUrl = inject("saveUrl");

  const isWeekday = computed(() => !!props.modalId);

  const validFrom = computed(() =>
    props.entries[0].validFrom ? dayjs(props.entries[0].validFrom?.date).format("DD.MM.YYYY") : null
  );
  const validUntil = computed(() =>
    props.entries[0]
      ? props.entries[0].validUntil?.date
        ? dayjs(props.entries[0].validUntil?.date).format("DD.MM.YYYY")
        : null
      : null
  );

  const timeFrame = computed(() => {
    if (!validFrom.value) return "Sonderöffnungszeiten";
    return validUntil.value
      ? `Gültig zwischen dem ${validFrom.value} - ${validUntil.value}`
      : `Gültig ab dem ${validFrom.value}`;
  });

return (_ctx, _cache) => {
  const _component_b_button = _resolveComponent("b-button")
  const _directive_b_modal = _resolveDirective("b-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(timeFrame.value), 1 /* TEXT */),
      (isWeekday.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_unref(permissions).canEdit)
              ? _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                  key: 0,
                  size: "sm",
                  variant: "outline-primary"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })), [
                  [_directive_b_modal, __props.modalId]
                ])
              : _createCommentVNode("v-if", true),
            _createVNode(WeekdayOpeningHours, {
              "initial-values": __props.entries,
              "save-url": _unref(saveUrl),
              "modal-id": __props.modalId
            }, null, 8 /* PROPS */, ["initial-values", "save-url", "modal-id"]),
            _createVNode(DeleteEntries, {
              "show-select": "",
              entries: __props.entries
            }, null, 8 /* PROPS */, ["entries"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(OpeningHoursTable, {
      items: __props.entries,
      permissions: _unref(permissions)
    }, null, 8 /* PROPS */, ["items", "permissions"])
  ]))
}
}

}